interface ICheckIsTaskInMilestoneTimeRange {
	milestoneStartDate?: number;
	milestoneEndDate?: number;
	associatedTaskStartDate?: number;
	associatedTaskEndDate?: number;
}

export const checkIsTaskInMilestoneTimeRange = ({
	milestoneStartDate,
	milestoneEndDate,
	associatedTaskStartDate,
	associatedTaskEndDate,
}: ICheckIsTaskInMilestoneTimeRange): boolean => {
	if (!milestoneStartDate || !milestoneEndDate) return false;

	const isStartDateInRange = associatedTaskStartDate ? milestoneStartDate <= associatedTaskStartDate : true;

	const isEndDateInRange = associatedTaskEndDate ? milestoneEndDate >= associatedTaskEndDate : true;

	return isStartDateInRange && isEndDateInRange;
};
